module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Hato Press")]), _vm._v(" "), _c('p', [_vm._v("217 Mare Street"), _c('br'), _vm._v("E8 3QE London")]), _vm._v(" "), _c('p', [_vm._v("+44 (0) 20 7729 5585"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@hatopress.net"
    }
  }, [_vm._v("info@hatopress.net")]), _c('br'), _c('a', {
    attrs: {
      "href": "https://instagram.com/hatopress",
      "target": "_blank"
    }
  }, [_vm._v("@hatopress")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Printing")]), _vm._v(" "), _c('p', [_vm._v("Got a question about the printing process or setting up your artwork?")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:info@hatopress.net"
    }
  }, [_vm._v("info@hatopress.net")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Workshops")]), _vm._v(" "), _c('p', [_vm._v("All our workshops are framed around our belief that having fun is the best way to learn something new.")]), _vm._v(" "), _c('p', [_vm._v("For workshop classes and general enquiry: "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")])]), _vm._v(" "), _c('p', [_vm._v("For bespoke workshops, strategy or partnership: "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net"
    }
  }, [_vm._v("bespoke@hatopress.net")])])]), _vm._v(" "), _c('div', {
    staticClass: "department"
  }, [_c('h4', [_vm._v("Shop")]), _vm._v(" "), _c('p', [_vm._v("Get a copy of our latest books, prints, stationery and more.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:shop@hatopress.net"
    }
  }, [_vm._v("shop@hatopress.net")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42c37b7b","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HatoPressFooter.vue
// module id = 212
// module chunks = 1